import React from 'react';
import { Container } from '@mui/material';
import Layout from '../../components/Layout';
import ManagerReportsSection from '../../components/manager/ManagerReportsSection';

const DriverReports = () => (
  <Layout>
    <Container maxWidth="lg">
      <ManagerReportsSection reportsApiPath="/drivers/reports/" selfView />
    </Container>
  </Layout>
);

export default DriverReports;
